import { ExtensionInfo } from "lavva.exalushome/build/js/Services/Controller/ControllerExtensionsService";
import { IconType, ManuallyPairedDevice } from "lavva.exalushome/build/js/Services/Devices/IDevice";
import { IManuallyPairedDevicesProtocolService } from "lavva.exalushome/build/js/Services/Devices/IManuallyPairedDevicesProtocolService";
import { DeviceTaskExecutionResult } from "lavva.exalushome/build/js/Services/Devices/TaskExecutionResult";
import { DataFrame, Method, Status } from "lavva.exalushome/build/js/DataFrame";
import { Api } from "lavva.exalushome";
import { IExalusConnectionService } from "lavva.exalushome/build/js/Services/IExalusConnectionService";
import { ExalusConnectionService } from "lavva.exalushome/build/js/Services/ExalusConnectionService";
import { ControllerConfigurationService } from 'lavva.exalushome/build/js/Services/Controller/ControllerConfigurationService';
import { IControllerConfigurationService } from "lavva.exalushome/build/js/Services/Controller/IControllerConfigurationService";
import { ILoggerService } from "lavva.exalushome/build/js/Services/Logging/ILoggerService";
import { LoggerService } from "lavva.exalushome/build/js/Services/Logging/LoggerService";

export class ManuallyPairedDeviceService implements IManuallyPairedDevicesProtocolService {
    private static readonly ServiceName = "PortosManualDevicePairingService"

    private _protocolGuid: string;
    private _connection: IExalusConnectionService;
    private _protocolExtGuid: string;

    constructor(extInfo: ExtensionInfo) {
        this._protocolGuid = extInfo.ExtensionGuid;
        this._protocolExtGuid = extInfo.ExtensionGuid;
        this._connection = Api.Get<IExalusConnectionService>(ExalusConnectionService.ServiceName);
    }

    get ProtocolExtensionGuid(): string {
        return this._protocolExtGuid;
    }

    get ProtocolGuid(): string {
        return this._protocolGuid;
    }

    GetServiceName(): string {
        return ManuallyPairedDeviceService.ServiceName;
    }

    async GetDevicesForManualPairingAsync(): Promise<ManuallyPairedDevice[]> {
        const result = await this._connection?.SendAndWaitForResponseAsync<ManualDeviceResult[]>(new GetManualPairDevicesRequest(), 8000, false);

        if (result == null || result.Data == null || result.Status != Status.OK)
            return [];

        return result.Data.map(rawDev=>{
            const device = new ManualDevice();
            device.Channels = rawDev.Channels;
            device.Description = rawDev.Description;
            device.Model = rawDev.Model;
            device.ModelGuid = rawDev.ModelGuid;
            device.ProtocolExtensionGuid = this._protocolExtGuid;
            device.IconType = rawDev.IconType;
            return device;
        })
    }

    async AddManuallyPairedDeviceAsync(device: ManuallyPairedDevice): Promise<DeviceTaskExecutionResult> {
        const result = await this._connection?.SendAndWaitForResponseAsync<ManualDeviceResult[]>(new PairManualDeviceRequest(device.ModelGuid), 8000, false);
        
        Api.Get<ILoggerService>(LoggerService.ServiceName).Error(ManuallyPairedDeviceService.ServiceName, `EXIT CONFIGURATION MODE WILL BE FIRED! AddManuallyPairedDeviceAsync()`);
        await Api.Get<IControllerConfigurationService>(ControllerConfigurationService.ServiceName).ExitConfigurationModeAsync();
        
        if (result == null || result.Status == null || result.Status != Status.OK)
            return DeviceTaskExecutionResult.Failed

        if (result.Data == null)
            return DeviceTaskExecutionResult.Unknown

        return DeviceTaskExecutionResult.Executed;
    }
}

class ManualDeviceResult {
    ModelGuid: string = "";
    Model: string = "";
    Description: string = "";
    Channels: number = 0;
    IconType: IconType = IconType.Unknown;
}

class ManualDevice implements ManuallyPairedDevice {
    private _modelGuid: string = "";
    private _model: string = "";
    private _description: string = "";
    private _channels: number = 0;
    private _protocolExtGuid: string = "";
    private _iconType: IconType = IconType.Unknown;

    get IconType(): IconType {
        return this._iconType;
    }

    set IconType(value: IconType) {
        this._iconType = value;
    }
    
    get ModelGuid(): string {
        return this._modelGuid;
    }

    set ModelGuid(value: string) {
        this._modelGuid = value;
    }

    get Model(): string {
        return this._model;
    }

    set Model(value: string) {
        this._model = value;
    }

    get Description(): string {
        return this._description;
    }

    set Description(value: string) {
        this._description = value;
    }

    get Channels(): number {
        return this._channels;
    }

    set Channels(value: number) {
        this._channels = value;
    }

    set ProtocolExtensionGuid(value: string) {
        this._protocolExtGuid = value;
    }

    get ProtocolExtensionGuid(): string {
        return this._protocolExtGuid;
    }
}

class GetManualPairDevicesRequest extends DataFrame<any> {
    constructor() {
        super();
        this.Resource = "/portos/devices/manual/pair/available";
        this.Method = Method.Get;
    }
}

class PairManualDeviceRequest extends DataFrame<any> {
    constructor(modelGuid: string) {
        super();
        this.Resource = "/portos/devices/device/create";
        this.Method = Method.Put;
        this.Data = { DeviceModelGuid: modelGuid }
    }
}